import React from "react";
import ScrollAnimation from "./animations/ScrollAnimation";

// import images
import ImgExperiencesMobile from "../../assets/png/img-experience-mobile.webp";
import ImgExperiencesWeb from "../../assets/png/img-experience-web.webp";

const ExperiencesHome = () => {
  return (
    <section className="bg-background ">
      {/* div main */}
      <div className="max-w-[1500px] xl:mx-auto">
        {/* div titles */}
        <ScrollAnimation direction="top">
          <div className="flex flex-col pt-12 space-y-3 text-white pl-9 lg:pl-40 lg:pt-40 lg:mb-24">
            <h3 className="max-w-[249px] sm:max-w-[800px] lg:max-w-[1100px] lg:text-2xl">
              Notre savoir-faire de bout-en-bout
            </h3>
            <h2 className="max-w-[290px] sm:max-w-[800px] lg:max-w-[1100px] lg:text-[55px] lg:leading-[70px]">
              Créons une expérience qui compte vraiment pour vos utilisateurs et
              votre business
            </h2>
          </div>
        </ScrollAnimation>
        <ScrollAnimation direction="right" delay={1}>
          <div>
            <img
              className="pb-28 lg:hidden"
              src={ImgExperiencesMobile}
              alt="img experiences"
            />
            <img
              className="hidden md:max-w-[700px] lg:block lg:max-w-[1000px] xl:max-w-[1276px]"
              src={ImgExperiencesWeb}
              alt="img experiences"
              width={5104}
              height={5544}
            />
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
};

export default ExperiencesHome;
